<template>
  <div>
    <p>Conflict is at the core of every gripping tale. Heroes might bring battles to their enemies, solve sinister secrets or set out on risky explorations. Which sort of story do you like the most?</p>
    <poll-images id="f834ab28-76bd-451c-868d-50741e249f57"></poll-images>
    <poll id="f834ab28-76bd-451c-868d-50741e249f57"></poll>
  </div>
</template>
